<template>
  <!--
    The view for the Group NotifyWizard-component.
    Used to send message to group.
  -->
  <Portlet
    :title="$t('notify')"
    :sub-title="$t('smsView.sendMessage')"
    icon="flag"
  >
    <NotifyGroupWizard
      :installation-id="installationId"
    />
  </Portlet>
</template>

<script>
export default {
  name: "NotifyGroup",
  components: {
    NotifyGroupWizard: () => import('@/components/NotifyWizard/NotifyGroupWizard.vue'),
  },
  props: {
    installationId: {
      type: String,
      required: true
    }
  },
  metaInfo () {
    return {
      title: this.$t('notifyWizard')
    }
  }
}
</script>
